"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _ButtonLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/ButtonLink"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Edit2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Edit"));
var _Visibility2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Visibility"));
var _VisibilityOff2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/VisibilityOff"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _InputField = _interopRequireDefault(require("../../../../InputField"));
var _Header2 = _interopRequireDefault(require("../../Header/Header"));
var _jsxRuntime = require("react/jsx-runtime");
var _Header, _Edit, _VisibilityOff, _Visibility, _FormattedMessage, _FormattedMessage2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Password = _ref => {
  let {
    email,
    canChangeEmail,
    password,
    isPasswordVisible,
    error,
    validator,
    isSigningIn,
    onChangeEmail,
    onPasswordChange,
    onTogglePasswordVisibility,
    onForgotPassword,
    onSignIn
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [_Header || (_Header = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header2.default, {
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.login_title.continue_to_account"
      }),
      description: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.password_title.fill_in"
      })
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-Password",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
        onSubmit: onSignIn,
        name: "loginPassword",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
          children: [error != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
            dataTest: "MagicLogin-PasswordAlert",
            type: "critical",
            icon: true,
            labelClose: intl.formatMessage({
              id: "orbit.button_close"
            }),
            children: error
          }), canChangeEmail ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            dataTest: "MagicLogin-EditEmail",
            type: "primarySubtle",
            iconRight: _Edit || (_Edit = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Edit2.default, {
              size: "small"
            })),
            onClick: onChangeEmail,
            fullWidth: true,
            children: email
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            weight: "bold",
            children: email
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputField.default, {
            autoFocus: true,
            label: intl.formatMessage({
              id: "account.password_input"
            }),
            validate: validator,
            type: isPasswordVisible ? "text" : "password",
            autoComplete: "current-password",
            name: "password",
            dataTest: "MagicLogin-PasswordInput",
            value: password,
            onChange: onPasswordChange,
            suffix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonLink.default, {
              compact: true,
              type: "primary",
              iconLeft: isPasswordVisible ? _VisibilityOff || (_VisibilityOff = /*#__PURE__*/(0, _jsxRuntime.jsx)(_VisibilityOff2.default, {})) : _Visibility || (_Visibility = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Visibility2.default, {})),
              onClick: onTogglePasswordVisibility
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            align: "center",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
              onClick: onForgotPassword,
              dataTest: "MagicLogin-PasswordReset",
              children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
                id: "account.forgot_password"
              }))
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            fullWidth: true,
            submit: true,
            loading: isSigningIn,
            children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
              id: "account.sign_in"
            }))
          })]
        })
      })
    })]
  });
};
var _default = exports.default = Password;